import axios from "../../customAxios";
import {
  NEGOTIATION_LIST_REQUEST,
  NEGOTIATION_LIST_SUCCESS,
  NEGOTIATION_LIST_FAIL,
  NEGOTIATION_ATTEMPT_DELETE_REQUEST,
  NEGOTIATION_ATTEMPT_DELETE_SUCCESS,
  NEGOTIATION_ATTEMPT_DELETE_FAIL,
} from "../constants/negotiationConstants";

export const fetchNegotiations = (page = 1, itemsPerPage = 10, searchTerm = "") => async (dispatch) => {
  try {
    dispatch({ type: NEGOTIATION_LIST_REQUEST });

    const { data } = await axios.get(`/api/v1/admin/negotiations`, {
      params: { page, itemsPerPage, search: searchTerm },
    });

    dispatch({
      type: NEGOTIATION_LIST_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: NEGOTIATION_LIST_FAIL,
      payload: error.response?.data?.message || error.message || "Something went wrong",
    });
  }
};

export const deleteNegotiationAttempt = (negotiationId, attemptIndex) => async (dispatch) => {
    try {
      dispatch({ type: NEGOTIATION_ATTEMPT_DELETE_REQUEST });
  
      const { data } = await axios.delete(`/api/v1/admin/negotiations/${negotiationId}/attempts/${attemptIndex}`);
  
      dispatch({
        type: NEGOTIATION_ATTEMPT_DELETE_SUCCESS,
        payload: data.negotiation,
      });
  
      return data.message;
    } catch (error) {
      dispatch({
        type: NEGOTIATION_ATTEMPT_DELETE_FAIL,
        payload: error.response?.data?.message || error.message || "Something went wrong",
      });
      throw new Error(error.response?.data?.message || error.message);
    }
  };